import { PERIOD_SORT } from "library/SFG20/constants.mjs"
const preferredOrder = ["Year", "Month", "Week", "Day", "Hour"]
export function convertIntervalInHoursToFrequency(
    time,
    defaultValue = {
        interval: 0,
        period: "Unknown",
    }
) {
    for (const period of preferredOrder) {
        const value = time / PERIOD_SORT[period]
        if (Math.abs(value - Math.floor(value)) < 0.0001) {
            if (Math.round(value) === 0) {
                return {
                    interval: 0,
                    period: "Unknown",
                }
            }
            return {
                interval: Math.floor(value),
                period,
            }
        }
    }
    return defaultValue
}
